import './beam-navigation.css'

import { REDESIGN_ROOT_PATH } from '../../helpers'
import { TUser } from '../../utils/types'
import { ReactComponent as Home } from './assets/home.svg'
import { ReactComponent as Mail } from './assets/mail.svg'
import { ReactComponent as NonprofitPartners } from './assets/nonprofitPartners.svg'
import { ReactComponent as PieChart } from './assets/pieChart.svg'
import { ReactComponent as Wallet } from './assets/wallet.svg'
import { BeamSideNavigationLink } from './BeamSideNavigationLink'
import { BeamUserBadge } from './BeamUserBadge'

interface PartnerSideNavBarProps {
  user: TUser
  pathname: string | null
  toggleFunction?: () => void
  invoicesCount?: number
}

const partnerLinks = [
  { label: 'Overview', icon: <Home />, link: `${REDESIGN_ROOT_PATH}/overview` },
  { label: 'Analytics & Reports', icon: <PieChart />, link: `${REDESIGN_ROOT_PATH}/reports` },
  {
    label: 'Nonprofit Partners',
    icon: <NonprofitPartners />,
    link: `${REDESIGN_ROOT_PATH}/nonprofits`,
  },
  { label: 'Invoices', icon: <Wallet />, link: `${REDESIGN_ROOT_PATH}/invoices` },
  { label: 'Contact Us', icon: <Mail />, link: `${REDESIGN_ROOT_PATH}/contact-support` },
]

export const BeamSideNavigation = ({ user, pathname, toggleFunction }: PartnerSideNavBarProps) => {
  return (
    <div className="beam-navigation" onClick={toggleFunction} onKeyDown={toggleFunction}>
      <div className="beam-navigation--links">
        {partnerLinks.map(partnerLink => (
          <BeamSideNavigationLink
            key={partnerLink.label}
            path={partnerLink.link}
            active={pathname?.startsWith(partnerLink.link)}>
            {partnerLink.icon}
            <span className="beam-navigation--link">{partnerLink.label}</span>
          </BeamSideNavigationLink>
        ))}
      </div>
      <BeamUserBadge user={user} />
    </div>
  )
}
